<template>
  <div class="clearfix">
    <el-row style="width: 1340px;" :gutter="10">
      <el-col :span="12">
        <el-form-item :label="$locale('rules.sellTogether')" style="width: 100%;">
          <el-row :gutter="10">
            <el-col style="width: 295px;">
              <el-select
                v-model="data.type"
                @change="getShopTypeList"
                clearable
              >
                <el-option :label="$locale('sideMenu.shop.concession')" value="concession"></el-option>
                <el-option :label="$locale('global.commercial')" value="commercial"></el-option>
                <el-option :label="$locale('setting.device.grouptab.set')" value="goodsPackage"></el-option>
              </el-select>
            </el-col>
            <el-col style="width: 375px;">
              <el-select v-model="data.id" @change="getPrice" clearable filterable>
                <el-option
                  v-for="(item, idx) in shopItemList"
                  :key="idx"
                  :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$locale('rules.shopItemsAmount')" style="width: 100%;">
          <el-row :gutter="10">
            <el-col style="width: 435px;">
              <el-input v-model="data.price"  prefix-icon="el-icon-money" @input="validatePrice" @blur="updatePrice_fn" />
            </el-col>
            <el-col style="width: 110px;">
              <el-button class="handle-btn egl-btn-white-gray-border" @click="removeItem(index)" v-if="comboItemsLength > 1">
                <i class="el-icon-minus"></i>
              </el-button>
              <el-button class="handle-btn egl-btn-white-gray-border" @click="addItem" v-if="index === comboItemsLength - 1">
                <i class="el-icon-plus"></i>
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>

import { shopTypeEnum } from "@/assets/js/sellTogether.js";
import { number_reg } from "@/utils/regExp";
export default {
  data() {
    return {
      shopItemList: [],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0,
    },
    list: {
      type: Array,
      default: () => []
    },
    comboItemsLength: {
      type: Number,
      default: 0
    },
    price: {
      type: [Number, String],
      default: 0
    },
    shopItemTotal: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getShopTypeList() {
      if (this.data.id) {
        this.data.id = "";
      }
      if (this.data.price) {
        this.data.price = "";
      }
      if (this.data.type) {
        shopTypeEnum[this.data.type]({
          approve: true,
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: 0,
          pageSize: 99999
        }).then(res => {
          if (this.data.type === "commercial") {
            this.shopItemList = res.data.data.filter(item => item.commercialTypeEnum === "default")
              .map(shop => ({
                id: shop.id,
                name: shop.name,
                price: shop.price
              }));
          } else {
            this.shopItemList = res.data.data.map(item => ({
              id: item.id,
              name: item.name,
              price: item.price
            }));
          }
        });
      } else {
        this.shopItemList = [];
      }
    },
    getPrice(id) {
      this.data.price = (this.shopItemList.find(item => item.id === id) || {}).price || null;
      this.$nextTick(() => {
        this.updatePrice_fn();
      });
    },
    addItem() {
      this.$emit("update", "add");
    },
    removeItem(index) {
      this.$emit("update", "remove", index);
    },
    validatePrice(value) {
      if (!number_reg.test(value)) {
        this.data.price = null;
      }
    },
    updatePrice_fn() {
      if (Number(this.price) < this.shopItemTotal) {
        this.$emit("updatePrice");
      }
    }
  },
  watch: {
    list: {
      handler(nv) {
        if (nv && nv.length > 0) {
          this.shopItemList = nv;
        }
      },
      immediate: true
    }
  }
};
</script>